import React, { useRef, useEffect, useCallback, useState} from 'react';
import {initializeEffect, effectOptions} from 'components/effects/constants.js';
import Colors from 'components/Colors.js';
import ParameterBox from "components/instruments/ParameterBox.js";
import AudioFXMenu from "components/pulled/AudioFXMenu.js";
import {useContextMenu} from "components/dropdowns/useContextMenu.js";
import EffectInput from './EffectInput.js';
import EffectOutput from './EffectOutput.js';
import {useWindowManager} from "components/windows/useWindowManager.js";
import {
    setParameterToMap,
    setEffectCollapsed} from 'actions/index.js';

import {connect} from 'react-redux';

const colors = new Colors();
const DOUBLE_CLICK_TIME = 450;

const PadEffectControl = ({
    pad,
    setIsCollapsed,
    isCollapsed,
    coords,
    isSelected,
    ...props
}) => { 
    const ref = useRef(undefined);
    const lastClick = useRef(undefined);
    let parameter = pad.fxMacro.macroParameter;

    useEffect(() => {
        setIsCollapsed(pad.effectRack.isCollapsed);
    }, []);

    useEffect(() => {
        pad.effectRack.isCollapsed = isCollapsed;
    }, [isCollapsed]);
    
    const {onContextMenu, dropdownPos, setDropdownPos} = useContextMenu({ref});
    const dropdownPosRef = useRef({x:0, y:0});

    const windowMgmt = useWindowManager({
        ref: ref,
        element: pad.effectRack,
        windowPosition: coords,
        sequencerEngine: pad.sequencerEngine,
        ...props
    });


    let {style, isDragging, onMouseDown, onMouseUp, setCoords} = windowMgmt;

    useEffect(() => {
        if (coords) {
            dropdownPosRef.current = {
                x: coords.x + 100,
                y: coords.y + 50,
            };
        }
    }, [coords]);

    const onClick = useCallback((e) => {
        e.stopPropagation();
        if (props.isMacroMapping) {
            if (!parameter.isMapped) {
                props.setParameterToMap(parameter);
            }
        }

        let time = new Date().getTime();
        e.stopPropagation();
        if (time - lastClick.current <= DOUBLE_CLICK_TIME) {
            pad.effectRack.isCollapsed = !isCollapsed;
            setIsCollapsed(!isCollapsed);
        }
        lastClick.current = time;
    }, [props.isMacroMapping, setIsCollapsed, isCollapsed]);

    let className = "pad-effect-control";
    if (!isCollapsed) {
        className += " expanded";
    }
    if (isSelected) {
        className += " selected";
    }

    let _style = {
        ... style,
        backgroundColor: colors.getColorForHash(pad.effectRack.id)
    };
    if (coords) {
        _style.left = coords.x;
        _style.top = coords.y;
    }

    if (props.isMacroMapping) {
        className += " plane-mapping";
    }

    if (props.hidden) {
        return '';
    }
    return [
        <div
          onClick={onClick}
          key={1}
          onContextMenu={(e) => {
              onContextMenu(e);
              windowMgmt.onContextMenu(e);
          }}
          onMouseDown={onMouseDown}
          onMouseUp={onMouseUp}
          ref={ref}
          style={_style}
          className={className}>
          <div className="control-inner">
          <ParameterBox color="white" name="" parameter={pad.fxMacro.macroParameter}/>
          <AudioFXMenu
              allowSendsOnly={true}
              effectOptions={effectOptions}
              initializeEffect={initializeEffect}
              addToBack={false}
              dropdownPosRef={dropdownPosRef}
              setDropdownPos={setDropdownPos}
              dropdownPos={dropdownPos}
              node={pad}/>
          <EffectInput containerRef={props.containerRef} pad={pad} fx={pad.effectRack}/>
          {!isCollapsed && <EffectOutput
                             outputNumber={0}
                             isControl={true} containerRef={props.containerRef} pad={pad} fx={pad.effectRack}/>}
          <div className="control-name">
            FX
          </div>
          </div>
        </div>,
    ];
}

const mapStateToProps = (state, props) => {
  return {
      coords: state.windows.windowPositions[props.pad.effectRack.id],
      isCollapsed: state.effects.effectCollapsed[props.pad.effectRack.id],
      isSelected: state.windows.selectedElements[props.pad.effectRack.id],
      isMacroMapping: state.effects.isMacroMapping,
      hidden: state.spatial.hiddenObjects[props.pad.id],
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
      setParameterToMap: parameter => dispatch(setParameterToMap(parameter)),
      setIsCollapsed: (x) => dispatch(
          setEffectCollapsed(props.pad.effectRack.id, x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PadEffectControl);
